import { Typography, Stack, Avatar, Box } from '@mui/material';
import Flag from '../../components/flag/Flag';

export default function Header() {
  return (
    <>
      <Stack direction="row" justifyContent="right" sx={{ pb: 5, pt: 0 }}>
        <Flag />
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Avatar src="/assets/logo/eotc-logo.png" alt="IMS-NSD logo" sx={{ width: 60, height: 60 }} />
        <Typography variant="h4" gutterBottom>
          የመግቢያ ገጽ
        </Typography>
      </Box>
    </>
  );
}
